import { render, staticRenderFns } from "./Plan-detail.vue?vue&type=template&id=d0083460"
import script from "./Plan-detail.vue?vue&type=script&lang=js"
export * from "./Plan-detail.vue?vue&type=script&lang=js"
import style0 from "./Plan-detail.vue?vue&type=style&index=0&id=d0083460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports